import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from '.'

const VisibilityCheckboxes = ({name, data, onChange, ...props}) => {
  const handleChange = (e) => {
    const newData = {
      ...data,
      [e.target.value]: e.target.checked
    }
    onChange(newData)
  }

  return (
    <div>
      <div className="flex flex-wrap -mx-2 lg:mx-0">
        <div className="w-1/2 lg:w-auto lg:mr-16 px-2 lg:px-0">
          <Checkbox
            className="mb-4 lg:mb-2"
            id={`${name}_checkbox1`}
            label="Public"
            name={name}
            value="public"
            checked={data.public}
            onChange={handleChange}
          />
        </div>
        <div className="w-1/2 lg:w-auto lg:mr-16 px-2 lg:px-0">
          <Checkbox
            className="mb-4 lg:mb-2"
            id={`${name}_checkbox2`}
            label="User"
            name={name}
            value="user"
            checked={data.user}
            onChange={handleChange}
          />
        </div>
        <div className="w-1/2 lg:w-auto lg:mr-16 px-2 lg:px-0">
          <Checkbox
            className="mb-4 lg:mb-2"
            id={`${name}_checkbox3`}
            label="Verified User"
            name={name}
            value="verified_user"
            checked={data.verified_user}
            onChange={handleChange}
          />
        </div>
        <div className="w-1/2 lg:w-auto lg:mr-16 px-2 lg:px-0">
          <Checkbox
            className="mb-4 lg:mb-2"
            id={`${name}_checkbox4`}
            label="Organization"
            name={name}
            value="organization"
            checked={data.organization}
            onChange={handleChange}
          />
        </div>
        <div className="w-1/2 lg:w-auto lg:mr-16 px-2 lg:px-0">
          <Checkbox
            className="mb-4 lg:mb-2"
            id={`${name}_checkbox5`}
            label="My Organization"
            name={name}
            value="my_organization"
            checked={data.my_organization}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  )
}

VisibilityCheckboxes.propTypes = {
  name: PropTypes.string,
  data: PropTypes.object,
  onChange: PropTypes.func
}

VisibilityCheckboxes.defaultProps = {
  name: '',
  data: {
    public: false,
    user: false,
    verified_user: false,
    organization: false,
    my_organization: false
  },
  onChange: () => {}
}

export { VisibilityCheckboxes }
